<template>
  <RenderlessComponent>
    <slot />
  </RenderlessComponent>
</template>

<script>
  import RenderlessComponent from 'src/components/RenderlessComponent/RenderlessComponent.vue';
  import { notify } from 'src/notify.js';
  import { cancelRequest, handleApiErrors, handleRequestError } from 'src/services/api.js';

  export default {
    name: 'SavedFiltersProvider',
    components: { RenderlessComponent },
    props: {
      savedFilters: {
        type: Array,
        required: true,
      },
      resource: {
        type: Object,
        required: true,
      }
    },
    provide() {
      return { savedFilters: this.provision }
    },
    data() {
      return {
        provision: {
          items: [...this.savedFilters],
          remove: this.remove,
          save: this.save,
        },
        removeRequest: null,
        saveRequest: null,
      }
    },
    methods: {
      remove(savedFilter) {
        const { id } = savedFilter;
        cancelRequest(this.removeRequest);
        this.removeRequest = this.resource.delete({ id });
        this.removeRequest
          .then(({ data }) => {
            const { status, id, errors } = data;
            if (status === 'ok') {
              this.provision.items = this.provision.items.filter(savedFilter => savedFilter.id !== id);
            } else {
              handleApiErrors(errors);
            }
          })
          .catch(handleRequestError);
      },
      save(params) {
        cancelRequest(this.saveRequest);
        this.saveRequest = this.resource.save(params);
        this.saveRequest
          .then(({ data }) => {
            const { status, savedFilters, errors } = data;
            if (status === 'ok') {
              this.provision.items = savedFilters;
              notify({ message: 'Фильтры сохранены' });
            } else {
              handleApiErrors(errors);
            }
          })
          .catch(handleRequestError);
      }
    }
  };
</script>